import {Component, OnInit} from '@angular/core';
import {BlockAbstractComponent} from '@gallaghercp/core-frontend';

@Component({
    selector: 'core-one-page-actions',
    templateUrl: './one-page-actions.component.html',
    styleUrls: ['./one-page-actions.component.scss'],
    standalone: false
})

export class OnePageActionsComponent extends BlockAbstractComponent implements OnInit {

}
